(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gwp-in-pdp"] && !Shopify.designMode) return;
  try {
    class GwpCarousel extends HTMLElement {
    static STORAGE_KEY = 'uqora_gwp_claimed';

    constructor() {
      super();
      this.track = this.querySelector('[data-gwp-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gwp-slide]'));
      this.dotsContainer = this.querySelector('[data-gwp-dots]');
      this.dots = Array.from(this.querySelectorAll('.gwp-carousel__dot'));
      this.defaultEnabled = this.dataset.defaultEnabled === 'true';
      this.activeCampaignKey = null;

      // GWP selection state (not added to cart until main product is added)
      this.selectedVariantId = null;
      this.selectedProductTitle = null;
      this.selectedSlide = null;
    }

    async connectedCallback() {
      // Bound handlers for cleanup
      this._boundGwpClaimedHandler = () => this.handleGwpClaimed();
      this._boundCartUpdateHandler = (event) => this.handleCartUpdate(event.detail);
      this._boundCampaignUpdateHandler = () => this.handleCampaignUpdate();
      this._boundScrollHandler = this.handleScroll.bind(this);

      // Always bind cart update events so we can show/hide dynamically
      document.addEventListener('gwp:claimed', this._boundGwpClaimedHandler);
      document.addEventListener('gwp:cart-updated', this._boundCartUpdateHandler);
      window.addEventListener(
        window.UqoraCampaignOffers?.events?.stateUpdated || 'uqora:campaign-offer-updated',
        this._boundCampaignUpdateHandler
      );

      this.applyCampaignState();

      // Check cart and localStorage together
      const shouldShow = await this.checkShouldShow();

      if (!shouldShow) {
        this.style.display = 'none';
        return;
      }

      // Normal initialization
      this.style.display = 'block';
      this.bindEvents();
      this._initialized = true;
    }

    async checkShouldShow() {
      if (!this.isOfferEnabled()) return false;

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const hasGwpInCart = cart.items.some((item) => item.properties && item.properties._gwp_uqora);

        if (hasGwpInCart) {
          // GWP in cart - hide widget, ensure localStorage is set
          this.setClaimedInStorage();
          return false;
        }

        // No GWP in cart - check localStorage
        if (this.hasClaimedInStorage()) {
          if (cart.item_count === 0) {
            // Cart empty + localStorage set = post-purchase, stay hidden
            return false;
          }
          // Cart has items but no GWP = user removed GWP, clear localStorage, show widget
          this.clearClaimedFromStorage();
        }

        return true;
      } catch (error) {
        console.error('GWP check error:', error);
        return !this.hasClaimedInStorage();
      }
    }

    // localStorage helpers
    getClaimedStorageKey() {
      return this.activeCampaignKey
        ? `${GwpCarousel.STORAGE_KEY}_${this.activeCampaignKey}`
        : GwpCarousel.STORAGE_KEY;
    }

    hasClaimedInStorage() {
      try {
        return localStorage.getItem(this.getClaimedStorageKey()) === 'true';
      } catch (e) {
        return false;
      }
    }

    setClaimedInStorage() {
      try {
        localStorage.setItem(this.getClaimedStorageKey(), 'true');
      } catch (e) {
        // localStorage not available
      }
    }

    clearClaimedFromStorage() {
      try {
        localStorage.removeItem(this.getClaimedStorageKey());
      } catch (e) {
        // localStorage not available
      }
    }

    handleGwpClaimed() {
      this.setClaimedInStorage();
      this.style.display = 'none';
    }

    disconnectedCallback() {
      document.removeEventListener('gwp:claimed', this._boundGwpClaimedHandler);
      document.removeEventListener('gwp:cart-updated', this._boundCartUpdateHandler);
      window.removeEventListener(
        window.UqoraCampaignOffers?.events?.stateUpdated || 'uqora:campaign-offer-updated',
        this._boundCampaignUpdateHandler
      );
      if (this.track) {
        this.track.removeEventListener('scroll', this._boundScrollHandler);
      }
    }

    async checkCartForGwp() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (cart.item_count === 0) return true;

        const hasGwpClaimed = cart.items.some((item) => item.properties && item.properties._gwp_uqora);
        return !hasGwpClaimed;
      } catch (error) {
        console.error('GWP cart check error:', error);
        return true;
      }
    }

    bindEvents() {
      // Slide selection (click + keyboard)
      this.slides.forEach((slide) => {
        slide.addEventListener('click', () => this.handleSlideSelect(slide));

        slide.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleSlideSelect(slide);
          }
        });
      });

      // Mobile: track scroll for dot indicators
      if (this.track) {
        this.track.addEventListener('scroll', this._boundScrollHandler, { passive: true });
      }

      // Dot click handlers
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToPage(parseInt(dot.dataset.dotIndex, 10)));
      });
    }

    scrollToPage(pageIndex) {
      const scrollWidth = this.track.scrollWidth;
      const clientWidth = this.track.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Page 0 = start, Page 1 = end
      const scrollTo = pageIndex === 0 ? 0 : maxScroll;
      this.track.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }

    handleScroll() {
      if (!this.dots.length) return;

      const scrollLeft = this.track.scrollLeft;
      const scrollWidth = this.track.scrollWidth;
      const clientWidth = this.track.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Two pages: first half = page 0, second half = page 1
      const scrollPercent = maxScroll > 0 ? scrollLeft / maxScroll : 0;
      const activeIndex = scrollPercent > 0.5 ? 1 : 0;

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    async handleCartUpdate({ hasGwp }) {
      if (hasGwp) {
        this.setClaimedInStorage();
        this.style.display = 'none';
        return;
      }

      if (!this.isOfferEnabled()) {
        this.style.display = 'none';
        return;
      }

      // GWP not in cart - check if we should show the widget
      // If localStorage is already cleared (e.g., by orphan removal), show immediately
      if (!this.hasClaimedInStorage()) {
        this.showWidget();
        return;
      }

      // localStorage still set - check cart state to determine intent
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (cart.item_count === 0) {
          // Cart is empty and localStorage still set - likely post-purchase, stay hidden
          return;
        }

        // Cart has items but no GWP - user removed the GWP manually, allow re-selection
        this.clearClaimedFromStorage();
      } catch (e) {
        // On error, default to showing the widget
        this.clearClaimedFromStorage();
      }

      this.showWidget();
    }

    showWidget() {
      if (!this.isOfferEnabled()) {
        this.style.display = 'none';
        return;
      }

      const wasHidden = this.style.display === 'none';
      this.style.display = 'block';

      if (wasHidden && !this._initialized) {
        this.bindEvents();
        this._initialized = true;
      }

      // Reset selection state when showing again
      this.clearSelection();

      // Clear any stale GWP state in product forms
      document.dispatchEvent(new CustomEvent('gwp:deselected'));
    }

    getActiveCampaignKey() {
      return window.UqoraCampaignOffers?.getActiveOffer?.()?.key || null;
    }

    isOfferEnabled() {
      return !this.activeCampaignKey && this.defaultEnabled;
    }

    applyCampaignState() {
      this.activeCampaignKey = this.getActiveCampaignKey();
      this.classList.toggle('is-campaign', Boolean(this.activeCampaignKey));
    }

    async handleCampaignUpdate() {
      const previousCampaignKey = this.activeCampaignKey;
      this.applyCampaignState();

      if (previousCampaignKey !== this.activeCampaignKey) {
        this.clearSelection();
        document.dispatchEvent(new CustomEvent('gwp:deselected'));
      }

      const shouldShow = await this.checkShouldShow();
      if (shouldShow) {
        this.showWidget();
      } else {
        this.style.display = 'none';
      }
    }

    handleSlideSelect(slide) {
      // Ignore sold out slides
      if (slide.classList.contains('is-disabled') || slide.getAttribute('aria-disabled') === 'true') return;

      const variantId = slide.dataset.variantId;
      const productTitle = slide.dataset.productTitle;

      // Toggle off if clicking the already selected slide
      if (slide.classList.contains('is-selected')) {
        this.clearSelection();
        document.dispatchEvent(new CustomEvent('gwp:deselected'));
        return;
      }

      // Select new slide
      this.setSelection(slide, variantId, productTitle);

      document.dispatchEvent(
        new CustomEvent('gwp:selected', {
          detail: { variantId, title: productTitle },
        })
      );
    }

    setSelection(slide, variantId, productTitle) {
      if (this.selectedSlide && this.selectedSlide !== slide) {
        this.selectedSlide.classList.remove('is-selected');
        this.selectedSlide.setAttribute('aria-pressed', 'false');
      }

      this.selectedVariantId = variantId;
      this.selectedProductTitle = productTitle;
      this.selectedSlide = slide;

      slide.classList.add('is-selected');
      slide.setAttribute('aria-pressed', 'true');
    }

    clearSelection() {
      if (this.selectedSlide) {
        this.selectedSlide.classList.remove('is-selected');
        this.selectedSlide.setAttribute('aria-pressed', 'false');
      }

      this.selectedVariantId = null;
      this.selectedProductTitle = null;
      this.selectedSlide = null;
    }
  }

  if (!customElements.get('gwp-carousel')) {
    customElements.define('gwp-carousel', GwpCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
